// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar-module__aside__TbeYj","collapsed":"Sidebar-module__collapsed__S3Uiv"};